import type {
  CellDrillDownInfoTypes,
  CustomColumnDrillDownInfo,
  MeasureDrillDownInfo,
  MetricDrillDownInfo,
} from "../../../../../../../../api/types/svTypes.ts";
import { CellDrillDownInfoType } from "../../../../../../../../api/types/svTypes.ts";

export const isMeasureDrillDownInfo = (info: CellDrillDownInfoTypes): info is MeasureDrillDownInfo => {
  return (
    info.drillDownInfoType === CellDrillDownInfoType.Default || info.drillDownInfoType === CellDrillDownInfoType.Irr
  );
};

export const isIrrDrillDownInfo = (info: CellDrillDownInfoTypes): info is MeasureDrillDownInfo => {
  return info.drillDownInfoType === CellDrillDownInfoType.Irr;
};

export const isMetricDrillDownInfo = (info: CellDrillDownInfoTypes): info is MetricDrillDownInfo => {
  return info.drillDownInfoType === CellDrillDownInfoType.Metric;
};

export const isCustomColumnDrillDownInfo = (info: CellDrillDownInfoTypes): info is CustomColumnDrillDownInfo => {
  return info.drillDownInfoType === CellDrillDownInfoType.CustomColumn;
};
